import Action from '../Action';

const initialState = {
	activeTabKey: '1',
	activeSidebarKey: '1',
};

export default (state = initialState, action) => {
	switch (action.type) {
		case Action.UPDATE_ACTIVE_KEY:
			return { ...state, activeTabKey: action.activeTabKey };
		case Action.UPDATE_SIDEBAR_KEY:
			return { ...state, activeSidebarKey: action.activeSidebarKey };
		default:
			return state;
	}
};
